module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Thin.3c20abac.woff2";